var map = {
	"./blog.yml": 134,
	"./cloud.yml": 135,
	"./color.yml": 136,
	"./country.yml": 137,
	"./dio.yml": 138,
	"./doc.yml": 139,
	"./emoji.yml": 140,
	"./git.yml": 141,
	"./icon.yml": 142,
	"./license.yml": 143,
	"./link.yml": 144,
	"./metrics.yml": 145,
	"./people.yml": 146,
	"./soft.yml": 147,
	"./src.yml": 148,
	"./status.yml": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;